export class QueueManager {
  constructor() {
    this.queue = [];
    this.isSearching = false;
  }

  enqueue(task, key) {
    this.queue.push({task, key});
  }

  dequeue() {
    if (this.queue.length > 0 && !this.isSearching) {
      return this.queue.shift();
    }
  }

  /**
   * prioritizeTask function - prioritize task according to the key
   * @param {*} key - task key
   * @returns boolean
   */
  prioritizeTask(key) {
    this.isSearching = true;
    const taskIndex = this.getTaskIndex(key);
    let result = false;
    if (taskIndex > 0) {
      const task = this.queue.splice(taskIndex, 1);
      this.queue.unshift(...task);
      result = true;
    }
    this.isSearching = false;
    return result;
  }

  /**
   * updateTask function - update queued task by key
   * @param {*} newTask - new task to replace original task
   * @param {*} key - task key
   * @returns boolean
   */
  updateTask(newTask, key) {
    this.isSearching = true;
    const taskIndex = this.getTaskIndex(key);
    let result = false;
    if (taskIndex > -1) {
      this.queue[taskIndex].task = newTask;
      result = true;
    }
    this.isSearching = false;
    return result;
  }

  /**
   * removeTask function - remove task in queue by task key
   * @param {*} key - task key
   * @returns boolean
   */
  removeTask(key) {
    this.isSearching = true;
    const taskIndex = this.getTaskIndex(key);
    let result = false;
    if (taskIndex > -1) {
      this.queue.splice(taskIndex, 1);
      result = true;
    }
    this.isSearching = false;
    return result
  }

  clearQueue() {
    this.queue = [];
    return true;
  }

  getTaskIndex(key) {
    const queueLength = this.queue.length;
    let index = -1;
    for (let i = 0 ; i < queueLength; i++) {
      if(this.queue[i].key === key) {
        index = i;
        break;
      }
    }
    return index;
  }
}

export const QueueSingleton = new QueueManager();
